.button {
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:focus {
    box-shadow: 0 0 12px var(--highlight-blue);
  }
}

.icon {
  fill: var(--blue-02);
}
